import { NavLink, useLocation } from 'react-router-dom';
import { Users, Landmark, Receipt, UserX, BarChart3, UserSearch } from 'lucide-react';
import { useRole } from '../../hooks/useRole';
import { useBranding } from '../../contexts/BrandingContext';

const ClientsSidebar = () => {
    const location = useLocation();
    const { isAdmin } = useRole();
    const { tenantCode } = useBranding();

    const href = (path: string) => tenantCode ? `/${tenantCode}${path}` : path;

    const sections = [
        { path: '/clientes', label: 'Clientes', icon: Users, adminOnly: false },
        { path: '/clientes/sepa', label: 'SEPA', icon: Landmark, adminOnly: true },
        { path: '/clientes/otros-pagos', label: 'Otros pagos', icon: Receipt, adminOnly: false },
        { path: '/clientes/inactivos', label: 'De baja', icon: UserX, adminOnly: false },
        // D2 — personas que vinieron a probar una clase, sin ser clientes.
        { path: '/clientes/prospectos', label: 'Clases de prueba', icon: UserSearch, adminOnly: false },
        // Reportes apunta a `Reporting`, que existía desde siempre pero se quedó
        // sin ruta al rehacer esta navegación. No quitar la ruta sin quitar
        // también esta entrada: sin ella la URL cae en `:clientId` y
        // ClienteDetalle pide un cliente llamado "reportes" (400 y 500).
        { path: '/clientes/reportes', label: 'Reportes', icon: BarChart3, adminOnly: true },
    ].filter((s) => !s.adminOnly || isAdmin);

    // "Clientes" sigue marcado dentro del detalle (/clientes/:clientId), que no
    // corresponde a ninguna de las subsecciones — antes el menú se quedaba sin
    // ningún elemento activo al abrir un cliente.
    const subPaths = sections.map((s) => s.path).filter((p) => p !== '/clientes');
    const isSectionActive = (path: string) => {
        if (path !== '/clientes') return location.pathname === href(path);
        return location.pathname.startsWith(href('/clientes'))
            && !subPaths.some((p) => location.pathname === href(p));
    };

    return (
        // D4 — en móvil deja de ser columna: tira horizontal desplazable bajo la
        // cabecera, que es lo que cabe en 375px sin comerse el contenido.
        <nav className="w-full shrink-0 border-b border-gray-200 bg-white px-3 py-3 md:sticky md:top-16 md:h-[calc(100vh-4rem)] md:w-56 md:self-start md:overflow-y-auto md:border-b-0 md:border-r md:py-6">
            <p className="mb-3 hidden px-3 text-[11px] font-semibold uppercase tracking-wider text-gray-400 md:block">
                Gestión
            </p>
            <ul className="flex gap-1 overflow-x-auto md:block md:space-y-1 md:overflow-visible">
                {sections.map(({ path, label, icon: Icon }) => (
                    <li key={path} className="shrink-0">
                        <NavLink
                            to={href(path)}
                            className={`flex items-center gap-2.5 whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${isSectionActive(path)
                                ? 'bg-brand-primary font-semibold text-white'
                                : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                            }`}
                        >
                            <Icon size={16} />
                            {label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default ClientsSidebar;
